
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#989AB2","stroke":"#989AB2","stroke-width":".3","d":"M8.821 16.04c0-.103-.005-.207-.014-.31a73.79 73.79 0 003.51-3.265l.083-.082-.002-.005c2.24-2.248 4.235-4.606 5.67-6.583.731-1.006 1.302-1.898 1.647-2.58.175-.345.345-.725.409-1.084.064-.361.023-.727-.257-1.006-.299-.3-.685-.317-1.047-.227-.36.089-.724.29-1.024.47l.073.12-.073-.12c-.624.378-1.439.982-2.422 1.794C13.31 4.868 10.966 7.094 9.058 9l-.002-.002-.085.086a68.814 68.814 0 00-3.262 3.492 3.502 3.502 0 00-1.764.253h0l-.002.001-.013.006h0-.002a3.555 3.555 0 00-2.086 3.198h0v.008c0 .723-.063 1.374-.157 1.893-.094.524-.217.896-.327 1.074 0 0 0 0 0 0l-.485.783-.131.21.247.018.919.066a11.209 11.209 0 003.556-.339c.928-.25 1.792-.641 2.405-1.203h0l.004-.004h0c.644-.6.948-1.426.948-2.498zm-2.96-1.992l.02.005h.015l.018.003.067.018a2.017 2.017 0 01.821.496l.096-.096-.096.096c.428.428.616 1.013.613 1.573-.004.563-.199 1.075-.504 1.36-.37.34-.975.633-1.711.846a9.384 9.384 0 01-2.234.343c.183-.73.289-1.667.289-2.648A2.14 2.14 0 014.5 14.128a2.013 2.013 0 011.361-.08zm2.475.214a3.458 3.458 0 00-.534-.692h0a3.438 3.438 0 00-.643-.505c.66-.747 1.369-1.51 2.093-2.254.247.185.481.388.7.608h.001l.006.006h0c.234.228.449.476.641.741a68.585 68.585 0 01-2.264 2.096zm8.291-8.893c-1.4 1.875-3.215 3.972-5.013 5.793a7.364 7.364 0 00-.665-.746 7.922 7.922 0 00-.694-.615c2.01-2 3.99-3.838 5.598-5.197l-.096-.115.096.115c1.255-1.06 2.061-1.643 2.569-1.962-.462.89-1.274 2.029-1.795 2.727z"}})])
          )
        }
      }
    